export class AppConfig {
    public static apiRootUrl = '';
    public static hideGetDataFromGeuscalculator = true;

    public static authAuthorizeUrl = '';
    public static authAuthority = '';
    public static authEndSessionUrl = '';
    public static authClientId = '';
    public static authScope = '';
    public static authState = 'grundrisk';
    public static authReturnUrl = '';
    public static operatorCVR = '';
    public static dmpAdminRole = 'miljoe_grundrisk_dmp_admin';
    public static allowedRoles = ['miljoe_grundrisk_skriv', 'miljoe_grundrisk_laes', 'miljoe_grundrisk_foreloebigscreening'];
    public static fullAccessRoles = ['miljoe_grundrisk_reg', 'miljoe_grundrisk_dmp_admin'];
    public static overrulingScreeningRules = {
        exceedingFactorLimitation: 0.05,
        sumV1PolygonAreaExceedLimitation: 0.05,
        sumV2PolygonAreaExceedLimitation: 0.05
    };
    public static settings = {
        maxItems: 50,
        sessionStorage: {
            currentLanguage: 'currentLanguage'
        }
    };

    public static appInsightsConnectionString = '';

    public static apiUrls = {
        locations: {
            list: () => AppConfig.getApiRootUrl() + `locations`,
            getById: (id: string) => AppConfig.getApiRootUrl() + `locations/${id}`,
            getScreeningById: (id: string) => AppConfig.getApiRootUrl() + `locations/${id}`,
            createExternal: () => AppConfig.getApiRootUrl() + `locations/externals`,
            reassessPolygon: (id: string) => AppConfig.getApiRootUrl() + `locations/${id}/reassessPolygon`,
            getGeusData: (locationNumber: string) => AppConfig.getApiRootUrl() + `locations/${locationNumber}/geus-data`,
            geusCalculateDKjordLocation: (locationNumber: string) => AppConfig.getApiRootUrl() +
                `locations/${locationNumber}/geus-calculate-location`,
            checkJupiterXlDatabaseStatus: () => AppConfig.getApiRootUrl() + `locations/check-jupiter-database-alive`,
            fetchDkJordPolygons: (locationNumber: string) => AppConfig.getApiRootUrl() +
                `locations/${locationNumber}/fetch-dk-jord-polygon`,
            geusCalculateByPolygon: () => AppConfig.getApiRootUrl() + `locations/geus-calculate-by-polygon`,
            searchDkJordLocations: (locationNumber: string) => AppConfig.getApiRootUrl() + `locations/searchDkJordLocations?locationReference=${locationNumber}`,
            forceCreateLocation: () => AppConfig.getApiRootUrl() + `locations/forceCreateLocation`
        },
        riskCalculations: {
            getById: (id: string) => AppConfig.getApiRootUrl() + `riskCalculations/${id}`,
            start: () => AppConfig.getApiRootUrl() + `riskCalculations`,
            approve: (id: string) => AppConfig.getApiRootUrl() + `riskCalculations/${id}/approve`,
            unapprove: (id: string) => AppConfig.getApiRootUrl() + `riskCalculations/${id}/unapprove`,
            delete: (id: string) => AppConfig.getApiRootUrl() + `riskCalculations/${id}`,
            addcomment: (id: string) => AppConfig.getApiRootUrl() + `riskCalculations/${id}/comments`,
            list: () => AppConfig.getApiRootUrl() + `riskCalculations`,
            getCaseWorkers: () => AppConfig.getApiRootUrl() + `riskCalculations/caseWorkers`
        },
        compounds: {
            list: () => AppConfig.getApiRootUrl() + `compounds`,
        },
        screeningCompounds: {
            list: () => AppConfig.getApiRootUrl() + `compounds/screening`,
        },
        screenings: {
            getById: (id: string) => AppConfig.getApiRootUrl() + `screenings/${id}`,
            getScreeningResultHistories: (locationId: string) => AppConfig.getApiRootUrl()
                + `screenings/results/histories?locationId=${locationId}`,
            getScreeningHistories: (locationId: string) => AppConfig.getApiRootUrl()
                + `screenings/histories?locationId=${locationId}`,
            getResultDetails: (id: string) => AppConfig.getApiRootUrl() + `screenings/results/${id}`,
            getLocationDetails: (locationId: string) => AppConfig.getApiRootUrl()
                + `screenings/locations/${locationId}`
        },
        preliminaryScreenings: {
            getResultDetails: (id: string) => AppConfig.getApiRootUrl() + `preliminaryScreenings/results/${id}`,
            getLocationDetails: (locationId: string) => AppConfig.getApiRootUrl() + `preliminaryScreenings/locations/${locationId}`
        },
        statistics: {
            getScreeningsAndRiskAssessments: () => AppConfig.getApiRootUrl() + `statistics/screeningsAndRiskAssessments`,
            getLocationScreenings: () => AppConfig.getApiRootUrl() + `statistics/locationScreenings`,
            getRiskCalculations: () => AppConfig.getApiRootUrl() + `statistics/riskCalculations`
        },
    };

    public static getApiRootUrl(): string {
        return AppConfig.apiRootUrl;
    }
}
